<div class="panel-container">
    <header class="notices-title">Activity</header>
    <ng-container *ngIf="notices?.length; else noRecords">
        <div
            (click)="onNoticeClick(notice)"
            *ngFor="let notice of notices; let i = index"
            [ngClass]="notice.severity"
            class="notice-content">
            <div class="heading" [ngClass]="{ 'show-bold': !notice.isRead }">
                <span>{{ 'notices.' + notice.type + '.heading' | translate: notice.translateParams }}</span>
            </div>
            <div class="body">
                <span>{{ 'notices.' + notice.type + '.body' | translate: notice.translateParams }}</span>
            </div>
            <div *ngIf="notice.createdDate" class="notice-date">{{ notice.createdDate | date: 'dd/MM' }}</div>
            <div *ngIf="!notice.isRead" class="notice-new">New</div>
            <div class="notice-module">{{ notice.module?.toLowerCase() }}</div>
            <div class="notice-switch-read">
                <span>Mark as {{ notice.isRead ? 'unread' : 'read' }}</span>
                <ui-switch
                    size="small"
                    (click)="$event.stopPropagation()"
                    (change)="onMarkAsReadChanged(!notice.isRead, notice.noticeId!)"
                    [checked]="!notice.isRead">
                </ui-switch>
            </div>
            <div class="notice-close" (click)="$event.stopPropagation(); onNoticeClose(notice.noticeId!)">Dismiss</div>
        </div>
    </ng-container>
    <ng-template #noRecords>
        <div class="no-records-found">No Notices Found.</div>
    </ng-template>
</div>
